

export default {
    props: ['jposInfo0', 'jposInfo1', 'texteGrosJPO0', 'texteGrosJPO1',
        'texteMoyenJPO0', 'texteMoyenJPO1', 'textePetitJPO0', 'textePetitJPO1',
        'linkjposInfo0', 'linkjposInfo1'],
}
